import { LocaleKeys } from '../../../../locale/translation-types'

export enum TeflTypeEnum {
  TUITION_ACTIVITY = 'TUITION_ACTIVITY',
  TUITION_ONLY = 'TUITION_ONLY',
  FULL_DAY_OUTING = 'FULL_DAY_OUTING',
  ACTIVITY_ONLY = 'ACTIVITY_ONLY'
}

export const teflTypeEnumMapping: Record<TeflTypeEnum, LocaleKeys> = {
  TUITION_ACTIVITY: 'tefl.type.enum.TUITION_ACTIVITY',
  TUITION_ONLY: 'tefl.type.enum.TUITION_ONLY',
  FULL_DAY_OUTING: 'tefl.type.enum.FULL_DAY_OUTING',
  ACTIVITY_ONLY: 'tefl.type.enum.ACTIVITY_ONLY'
}
